import BenchlingConfig from 'BenchlingConfig';

const PROD_GLOBAL_ROLE_ARN = 'arn:aws:iam::436935034330:role/instruments-s3-gateway-global';
const DEV_GLOBAL_ROLE_ARN = 'arn:aws:iam::518020454864:role/instruments-s3-gateway-global';

// DEPLOY_ENVIRONMENT is "development"/"dev-manual" on non-prod stacks and
// "latest"/"stable"/region names on prod. Treat the known dev environments as
// dev and default everything else to the prod global role.
const DEV_DEPLOY_ENVIRONMENTS = new Set(['development', 'dev-manual']);

export function getGlobalRoleArn(): string {
  return DEV_DEPLOY_ENVIRONMENTS.has(BenchlingConfig.DEPLOY_ENVIRONMENT)
    ? DEV_GLOBAL_ROLE_ARN
    : PROD_GLOBAL_ROLE_ARN;
}

export function getBucketPolicy(bucketName: string, benchlingRoleArn: string): string {
  return JSON.stringify(
    {
      Version: '2012-10-17',
      Statement: [
        {
          Sid: 'BenchlingConnect',
          Effect: 'Allow',
          Principal: {AWS: benchlingRoleArn},
          Action: ['s3:ListBucket', 's3:GetObject', 's3:PutObject'],
          Resource: [`arn:aws:s3:::${bucketName}`, `arn:aws:s3:::${bucketName}/*`],
          Condition: {StringEquals: {'aws:PrincipalTag/TenantId': BenchlingConfig.TENANT_ID}},
        },
      ],
    },
    null,
    2
  );
}

export function getTrustPolicy(): string {
  const globalRoleArn = getGlobalRoleArn();
  const tenantId = BenchlingConfig.TENANT_ID;

  return JSON.stringify(
    {
      Version: '2012-10-17',
      Statement: [
        {
          Effect: 'Allow',
          Principal: {AWS: globalRoleArn},
          Action: 'sts:AssumeRole',
          Condition: {StringEquals: {'sts:ExternalId': tenantId}},
        },
      ],
    },
    null,
    2
  );
}

export function getPermissionsPolicy(bucketName: string): string {
  return JSON.stringify(
    {
      Version: '2012-10-17',
      Statement: [
        {
          Effect: 'Allow',
          Action: ['s3:ListBucket', 's3:GetObject', 's3:PutObject'],
          Resource: [`arn:aws:s3:::${bucketName}`, `arn:aws:s3:::${bucketName}/*`],
        },
      ],
    },
    null,
    2
  );
}
